import React from "react";
import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
  SvgIcon,
} from "@mui/material";

interface NavItemProps {
  label: string;
  path: string;
  icon: React.ElementType;
  active: boolean;
  onClick: (path: string) => void;
}

const NavItem: React.FC<NavItemProps> = ({
  label,
  path,
  icon: Icon,
  active,
  onClick,
}) => {
  return (
    <ListItemButton
      onClick={() => onClick(path)}
      sx={{
        color: active ? "primary.main" : "inherit",
        "&:hover": { backgroundColor: "unset" },
        px: 0,
        py: "8px",
      }}
    >
      <ListItemIcon sx={{ minWidth: "35px" }}>
        <SvgIcon color={active ? "primary" : "action"}>
          <Icon />
        </SvgIcon>
      </ListItemIcon>

      <ListItemText
        primary={label}
        sx={{
          "& .MuiListItemText-primary": {
            fontSize: "14px",
          },
        }}
      />
    </ListItemButton>
  );
};

export default NavItem;
